import React from 'react';
import AppLayout from 'components/AppLayout';

export default function Home() {
  return <>{/* <h1>I’m in a layout!</h1> */}</>;
}
